module.exports = __webpack_public_path__ + "static/media/shivangi.09812359.jpeg";